<template>
  <section>
    <div id="features" class="feature-section pb-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="section-heading text-center mb-5">
              <h2>
                {{ $t("landingPage.features.title") }}
              </h2>
              <p>
                {{ $t("landingPage.features.subtitle") }}
              </p>
            </div>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-lg-4">
            <div class="d-flex align-items-start mb-50">
              <div class="pr-4">
                <div class="icon icon-shape icon-color">
                  <img
                    src="../assets/background/free.svg"
                    alt=""
                    class="feature-img"
                  />
                </div>
              </div>
              <div class="icon-text">
                <h5>{{ $t("landingPage.features.tile1.title") }}</h5>
                <p class="mb-0">
                  {{ $t("landingPage.features.tile1.subtitle") }}
                </p>
              </div>
            </div>
            <div class="d-flex align-items-start mb-50">
              <div class="pr-4">
                <div class="icon icon-shape icon-color">
                  <img
                    src="../assets/background/whatsapp.svg"
                    alt=""
                    class="feature-img"
                  />
                </div>
              </div>
              <div class="icon-text">
                <h5>{{ $t("landingPage.features.tile2.title") }}</h5>
                <p class="mb-0">
                  {{ $t("landingPage.features.tile2.subtitle") }}
                </p>
              </div>
            </div>
            <div class="d-flex align-items-start">
              <div class="pr-4">
                <div class="icon icon-shape icon-color">
                  <img
                    src="../assets/background/limit.svg"
                    alt=""
                    class="feature-img"
                  />
                </div>
              </div>
              <div class="icon-text">
                <h5>{{ $t("landingPage.features.tile3.title") }}</h5>
                <p class="mb-0">
                  {{ $t("landingPage.features.tile3.subtitle") }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="position-relative display-flex" style="z-index: 10">
              <PinchZoom
                disableZoomControl="disable"
                doubleTap="true"
                style="background: transparent"
              >
                <img
                  alt="Image placeholder"
                  src="../assets/background/feature-sec.png"
                  class="img-center img-fluid feature-mbl"
                />
              </PinchZoom>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="d-flex align-items-start mb-50">
              <div class="pr-4">
                <div class="icon icon-shape icon-color">
                  <img
                    src="../assets/background/search.svg"
                    alt=""
                    class="feature-img"
                  />
                </div>
              </div>
              <div class="icon-text">
                <h5>{{ $t("landingPage.features.tile4.title") }}</h5>
                <p class="mb-0">
                  {{ $t("landingPage.features.tile4.subtitle") }}
                </p>
              </div>
            </div>
            <div class="d-flex align-items-start mb-50">
              <div class="pr-4">
                <div class="icon icon-shape icon-color">
                  <img
                    src="../assets/background/setting.svg"
                    alt=""
                    class="feature-img"
                  />
                </div>
              </div>
              <div class="icon-text">
                <h5>{{ $t("landingPage.features.tile5.title") }}</h5>
                <p class="mb-0">
                  {{ $t("landingPage.features.tile5.subtitle") }}
                </p>
              </div>
            </div>
            <div class="d-flex align-items-start">
              <div class="pr-4">
                <div class="icon icon-shape icon-color">
                  <img
                    src="../assets/background/connect.svg"
                    alt=""
                    class="feature-img"
                  />
                </div>
              </div>
              <div class="icon-text">
                <h5>{{ $t("landingPage.features.tile6.title") }}</h5>
                <p class="mb-0">
                  {{ $t("landingPage.features.tile6.subtitle") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="ta-center pt-5">
          <a
            href="#"
            class="customStartButton"
            v-if="!state.profile.isSigned"
            @click="startLogin"
          >
            {{ $t("landingPage.features.tryFree") }}
          </a>
          <a
            href="/admin"
            class="customStartButton"
            v-if="state.profile.isSigned"
          >
            {{ $t("header.t6") }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="css">
@media (min-width: 1750px) {
  div#features .row .col-lg-4:nth-child(1) .d-flex {
    justify-content: flex-end;
  }

  div#features .row .col-lg-4:nth-child(1) .d-flex .icon-text {
    width: 100%;
    max-width: 300px;
  }
}
</style>
<!--------------------------->
<script>
import { mapGetters } from "vuex";
import PinchZoom from "vue-pinch-zoom";
import { setLocale } from "../services/firebase";
export default {
  name: "Features",
  components: {
    PinchZoom,
  },
  mounted() {
    setLocale();
  },
  methods: {
    startLogin: function() {
      this.$store.dispatch("startLogin");
    },
  },
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
  },
  beforeMount() {
    var script = document.createElement("script");
    switch (this.$store.state.locale) {
      case "en":
        script.src =
          "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=en";
        document.getElementsByTagName("head")[0].appendChild(script);
        break;

      case "pt":
        script.src =
          "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=pt-BR";
        document.getElementsByTagName("head")[0].appendChild(script);
        break;

      case "ru":
        script.src =
          "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=ru";
        document.getElementsByTagName("head")[0].appendChild(script);
        break;

      case "es":
        script.src =
          "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=es-419";
        document.getElementsByTagName("head")[0].appendChild(script);
        break;
    }
  },
};
</script>
<style lang="scss">
.icon-text {
  h5 {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) 24px/36px Roboto;
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal bold 16px Roboto;
    letter-spacing: 0px;
    color: #444444;
    opacity: 1;
  }
  p {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-normal) 18px/24px Roboto;
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal normal 12px Roboto;
    letter-spacing: 0px;
    color: #888888;
    opacity: 1;
  }
}
.mb-50 {
  margin-bottom: 50px !important;
}
.feature-mbl {
  height: 350px;
}
.display-flex {
  display: flex;
  margin: auto;
  justify-content: center;
}
</style>
